<template>
  <div id="app">
    <!-- <div style="position: absolute">测试app根文件渲染</div> -->
    <!-- <loading-box></loading-box> -->
    <router-view :key="$route.fullPath" />
    <!-- <notify-android-pwa /> -->
  </div>
</template>

<script>
// import { canReportFinger } from "./util/getBrowserLang";
// import { addFingerUser } from "./util/APIUtils";
// import LoadingBox from "@/components/loading/LoadingBox";
// import { handlePwa } from "./util/pwaHelper";
// import NotifyAndroidPwa from "@/components/pwa/NotifyAndroidPwa";

export default {
  components: {
    // LoadingBox,
    // NotifyAndroidPwa,
  },
  data() {
    return {
      // language: this.$store.getters.language,
      // token: this.$store.getters.token,
      // clientWidth: {
      //   documentElement: document.documentElement.clientWidth,
      //   body: document.body.clientWidth,
      // },
    };
  },
  mounted() {},
  methods: {},

  created() {
    console.log("走到了App.vue");
    this.$store.dispatch("setDevice", this.clientWidth);
    // this.$store.dispatch("setInnerBrowserApp");
    // this.$store.getters.device.isPC
    //   ? ""
    //   : this.$store.dispatch("setMobileRoute", "mobile/");
    this.$store.dispatch("setPlatform");
    // handlePwa();
    // this.$store.dispatch("getFingerId").then(async () => {
    //   let fingerUser = {
    //     openId: this.$store.getters.openId,
    //     fingerId: this.$store.getters.fingerId,
    //   };
    //   if (canReportFinger(fingerUser)) {
    //     addFingerUser(fingerUser);
    //   }
    // });
  },
};
</script>

<style>
#app {
}
@media screen and (max-width: 320px) {
  #app {
    overflow: auto;
    overflow-x: hidden;
  }
}
</style>

